<template>
  <section>
    <VTitle text="AppCopyright" />
    <div class="example-component">
      <div class="example-component__controls">
        <VPropControl
          v-for="(propModel, propName) in propModels"
          :key="propName"
          :model="propModel"
          :name="propName"
        />
      </div>
      <div class="example-component__component">
        <AppCopyright :with-link="propModels.withLink.value" />
      </div>
    </div>
  </section>
</template>

<script>
import AppCopyright from '@/components/UIKit/Standard/Atoms/AppCopyright'
import AppPropModel from '@/components/UIKit/Standard/ViewerSections/classes/AppPropModel'
import VTitle from '@/components/UIKit/Standard/ViewerSections/components/snippets/VTitle'
import VPropControl from '@/components/UIKit/Standard/ViewerSections/components/snippets/VPropControl'

export default {
  name: 'AppCopyrightViewer',
  components: {
    AppCopyright,
    VTitle,
    VPropControl,
  },
  data() {
    return {
      propModels: {
        withLink: new AppPropModel({
          type: Boolean,
          defaultValue: true,
        }),
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.example-component {
  display: flex;
  justify-content: stretch;
  align-items: stretch;

  @at-root &__controls {
    background: #fff;
    padding: 30px;
    border: 1px solid var(--gray-200);
    flex-basis: 300px;
    border-radius: 12px;
  }

  @at-root &__component {
    padding: 30px;
    flex: 1;
  }
}
</style>
